import MapDisplay from "~/components/address/MapDisplay.tsx";
import Card from "~/components/Card";
import CardValue from "~/components/Card/components/CardValue.tsx";
import Label from "~/components/formElements/Label";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import type { Client } from "~/modules/client/api/client/clientTypes.ts";
import { useAllCurrencies } from "~/modules/country/api/currency/currencyQueries.ts";
import getOneOfCollection from "~/utils/getOneOfCollection.ts";

type ClientsBillingDetailsProps = {
	clientData: Client;
};

const ClientsBillingDetails: React.FunctionComponent<ClientsBillingDetailsProps> = ({
	clientData,
}) => {
	const {
		countryId,
		comment,
		currencyId,
		street,
		houseNumber,
		city,
		zipCode,
		invoiceByMail,
		paymentTargetDays,
		travelExpensesIncluded,
	} = clientData;

	const { data: allCurrenciesData } = useAllCurrencies();

	const currencyDisplayName = currencyId ? getOneOfCollection(allCurrenciesData, currencyId, "displayName") : "n/a";

	const showMap = !!street && !!houseNumber && !!zipCode && !!city && countryId;

	return (
		<div className="flex flex-col gap-y-8">
			<div className="grid w-full grid-cols-2 gap-x-2">
				<Card>
					<div className="grid grid-cols-2 gap-4">
						{[
							{
								label: "Rechnung per",
								value: invoiceByMail ? "Mail" : "Post",
							},

							{
								label: "Zahlungsziel",
								value: paymentTargetDays ? `${paymentTargetDays} Tage` : EMPTY_VALUE_PLACEHOLDER,
							},
							{
								label: "Reisekosten inkludiert",
								value: travelExpensesIncluded ? "Ja" : "Nein",
							},
							{
								label: "Währung",
								value: currencyDisplayName || EMPTY_VALUE_PLACEHOLDER,
							},

						].map(({ label, value }, index) => (
							<CardValue key={`contacts-${index}`}
									   label={label}>
								{value}
							</CardValue>
						))}
						<div className="col-span-2">
							<CardValue label="Rechnungsbesonderheiten">
								{comment || EMPTY_VALUE_PLACEHOLDER}
							</CardValue>
						</div>
					</div>
				</Card>
				<Card>
					<Label size="sm">Addresse</Label>
					{showMap ? <MapDisplay address={{
						street,
						houseNumber,
						zipCode,
						city,
						countryId,
					}} /> : EMPTY_VALUE_PLACEHOLDER}
				</Card>
			</div>
		</div>
	);
};

export default ClientsBillingDetails;